import { useState } from 'react'
import { Container, Dropdown, ListGroup, NavLink, Stack, Card, Badge, Button } from 'react-bootstrap'
import { FaQuestionCircle, FaEdit, FaTrash, FaEllipsisV, FaClock } from 'react-icons/fa'
import { useQuery } from 'react-query';
import { getFaqs } from '../../../api/agent';
import { ObjectId } from '../../../models';
import { IFAQ } from '../../../models/faq';
import DeleteDataItem from '../DeleteDataItem';
// import FAQStatus from './Train/FAQStatus';
import { useOrgContext } from '../../../context/org';
import EditFAQ from '../Views/EditFAQ';
import ManageFAQ from '../ManageFAQ';
import DataStatus from '../DataStatus';

type Props = {
    orgId: ObjectId;
	faqs: IFAQ[];
	permission: boolean;
}

function ListFAQs({orgId, faqs, permission}: Props) {
    const [editFAQ, setEditFAQ] = useState<IFAQ>();
    const [deleteItem, setDeleteItem] = useState<{
        show: boolean;
        id: string;
        name: string;
		agentId: string;
    }>({ show: false, id: '', name: '', agentId: '' });

    return (
        <>
            {
                editFAQ && 
                <ManageFAQ 
                    show={true}
                    setShow={(show) => !show && setEditFAQ(undefined)}
                    faq={editFAQ} 
                />
            }
            {
                <DeleteDataItem 
                    show={deleteItem.show}
                    onClose={() => setDeleteItem({ show: false, id: '', name: '', agentId: '' })}
                    orgId={orgId}
                    agentId={deleteItem.agentId}
                    itemId={deleteItem.id}
                    itemType="faq"
                    itemName={deleteItem.name}
                />
            }
            
            <div 
                className="mb-4"
                style={{ backgroundColor: "#2d2d2d", borderRadius: "12px", border: "1px solid #444" }}
            >
                {/* Header */}
                <div className="p-4 border-bottom" style={{ borderColor: "#555" }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div 
                                className="me-3 d-flex align-items-center justify-content-center"
                                style={{
                                    width: "32px",
                                    height: "32px",
                                    backgroundColor: "#ffc107",
                                    borderRadius: "8px"
                                }}
                            >
                                <FaQuestionCircle className="text-white" size={16} />
                            </div>
                            <h5 className="text-light mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
                                FAQ Collection
                            </h5>
                        </div>
                        <Badge bg="secondary" className="px-2 py-1">
                            {faqs.length} items
                        </Badge>
                    </div>
                </div>

                {/* Content */}
                <div className="p-0">
                    {faqs.map((faq, index) => (
                        <div 
                            key={index}
                            className="p-4 d-flex align-items-center justify-content-between"
                            style={{ 
                                borderBottom: index < faqs.length - 1 ? "1px solid #444" : "none",
                                transition: "background-color 0.2s ease"
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#333"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                        >
                            <div className="flex-grow-1">
                                <div className="d-flex align-items-center mb-2">
                                    <button
                                        className="btn btn-link p-0 text-decoration-none"
                                        onClick={() => setEditFAQ(faq)}
                                        style={{ 
                                            fontSize: "16px", 
                                            fontWeight: "500",
                                            color: "#fff",
                                            border: "none",
                                            background: "none",
                                            textAlign: "left"
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.color = "#007bff"}
                                        onMouseLeave={(e) => e.currentTarget.style.color = "#fff"}
                                    >
                                        {faq.question}
                                    </button>
                                </div>
                                <div className="d-flex align-items-center" style={{ fontSize: "14px", color: "#ccc" }}>
                                    <FaClock className="me-2" size={12} />
                                    <span>Updated {new Date(faq.updatedAt).toDateString()}</span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <DataStatus
                                        id={faq.id} 
                                        orgId={orgId}
                                        agentId={faq.agentId} 
                                        status={faq.status}
                                        type='faq'
                                    />
                                </div>
                                
                                <Dropdown align="end">
                                    <Dropdown.Toggle 
                                        variant="link"
                                        className="p-0 border-0"
                                        disabled={permission}
                                        style={{ fontSize: "14px", color: "#ccc" }}
                                    >
                                        <FaEllipsisV />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu
                                        style={{ 
                                            backgroundColor: "#333", 
                                            borderColor: "#555",
                                            minWidth: "120px"
                                        }}
                                    >
                                        <Dropdown.Item 
                                            onClick={() => setEditFAQ(faq)}
                                            className="d-flex align-items-center"
                                            style={{ 
                                                fontSize: "14px", 
                                                color: "#fff",
                                                backgroundColor: "transparent"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "#007bff";
                                                e.currentTarget.style.color = "#fff";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = "transparent";
                                                e.currentTarget.style.color = "#fff";
                                            }}
                                        >
                                            <FaEdit className="me-2" size={12} />
                                            Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item 
                                            onClick={() => setDeleteItem({ 
                                                show: true, 
                                                id: faq.id, 
                                                name: faq.question,
                                                agentId: faq.agentId
                                            })}
                                            className="d-flex align-items-center"
                                            style={{ 
                                                fontSize: "14px", 
                                                color: "#fff",
                                                backgroundColor: "transparent"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "#dc3545";
                                                e.currentTarget.style.color = "#fff";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = "transparent";
                                                e.currentTarget.style.color = "#fff";
                                            }}
                                        >
                                            <FaTrash className="me-2" size={12} />
                                            Delete
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default ListFAQs